const CroissantScoreBarPiecesConfig = {
    1: {
        radius: 7,
        x: 0,
        y: 12,
        width: 26,
        height: 9
    },
    2: {
        radius: 7,
        x: 26,
        y: 8,
        width: 34,
        height: 14
    },
    3: {
        radius: 9,
        x: 60,
        y: 2,
        width: 48,
        height: 20
    },
    4: {
        radius: 7,
        x: 108,
        y: 8,
        width: 34,
        height: 14
    },
    5: {
        radius: 7,
        x: 142,
        y: 12,
        width: 26,
        height: 9
    }
};

export default CroissantScoreBarPiecesConfig;
